import React from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import ArrowForwardIcon from 'components/material-symbol/icons/ArrowForward'
import { useStyles } from './styles'

const SessionSectionHeader = ({ title, linkLabel, onLinkClick, className }) => {
  const classes = useStyles()

  return (
    <Box className={`${classes.sectionHeader} ${className || ''}`}>
      <Typography component="h3" className={classes.sectionTitle}>
        {title}
      </Typography>
      {linkLabel && onLinkClick ? (
        <Button
          className={classes.sectionLink}
          onClick={onLinkClick}
          endIcon={<ArrowForwardIcon fontSize="small" opticalSize={16} />}
        >
          {linkLabel}
        </Button>
      ) : null}
    </Box>
  )
}

export default SessionSectionHeader
